/** กล่องยืนยันการกระทำที่ย้อนไม่ได้ — ใช้ `Modal` เดิม ไม่ใช้ `window.confirm` */

import type { ReactNode } from 'react';

import { Modal } from '../components/Modal';

export interface ConfirmModalProps {
  readonly open: boolean;
  readonly title: string;
  readonly children: ReactNode;
  readonly confirmLabel: string;
  readonly busy?: boolean;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}

export function ConfirmModal({
  open,
  title,
  children,
  confirmLabel,
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <div data-testid="confirm-modal">
        {children}
        <div className="cap-notice__actions">
          <button
            type="button"
            className="cap-button cap-button--primary"
            data-testid="confirm-modal-confirm"
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? 'กำลังดำเนินการ…' : confirmLabel}
          </button>
          <button
            type="button"
            className="cap-button cap-button--ghost"
            data-testid="confirm-modal-cancel"
            disabled={busy}
            onClick={onCancel}
          >
            ยกเลิก
          </button>
        </div>
      </div>
    </Modal>
  );
}
